module.exports = __webpack_public_path__ + "static/media/morphos_angled.b615ad7e.png";